export default __webpack_public_path__ + "static/media/river.e98dd014.svg";